import React from 'react';
import { Bone as LucideBone } from 'lucide-react';

const Bone = props => (
  <LucideBone {...props} />
);

export default Bone;
